import type { KnowledgeSourceType } from './api/types';

/** Типы файла, у каждого из которых своя подпись в списке */
export const NAMED_SOURCE_TYPES = ['pdf', 'word', 'excel', 'powerpoint'] as const;

/** Подпись источника любого прочего типа файла и источника без типа файла вовсе */
export const OTHER_SOURCE_TYPE = 'other';

/**
 * Значения, которыми список подписывает тип источника. Отбор и порядок по типу идут по ним же:
 * показанное значение должно годиться в условие, иначе часть источников отобрать нечем
 */
export const SOURCE_TYPE_LABELS = [...NAMED_SOURCE_TYPES, OTHER_SOURCE_TYPE] as const;

export type NamedSourceType = (typeof NAMED_SOURCE_TYPES)[number];

/** Тип источника в том виде, в каком список его показывает и принимает условием */
export type SourceTypeLabel = (typeof SOURCE_TYPE_LABELS)[number];

/** Тип источника подписан собственным названием */
export const isNamedSourceType = (sourceType: KnowledgeSourceType): sourceType is NamedSourceType =>
  (NAMED_SOURCE_TYPES as readonly string[]).includes(sourceType);

/** Значение, которым список подписывает тип источника */
export const getSourceTypeLabel = (sourceType: KnowledgeSourceType): SourceTypeLabel =>
  isNamedSourceType(sourceType) ? sourceType : OTHER_SOURCE_TYPE;
